import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GooglePlacesAutocompleteService } from '@shared/services/google-places-autocomplete.service';
import { AuthService } from '@core/auth/auth.service';
import { Company } from '@shared/enums/company';

@Component({
  selector: 'app-google-places-autocomplete',
  templateUrl: './google-places-autocomplete.component.html',
  styleUrls: ['./google-places-autocomplete.component.scss'],
})
export class GooglePlacesAutocompleteComponent
  implements OnInit, AfterViewInit {
  @Output() onReset = new EventEmitter();
  detailForm: FormGroup;
  @ViewChild('googleAutocompleteEdit') googleAutocompleteEdit: ElementRef;
  companies = Company;
  isReadOnly = true;
  isSECA: boolean = false;
  protected readonly Company = Company;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private googlePlacesAutocomplete: GooglePlacesAutocompleteService
  ) {
  }

  @Input()
  set data(value) {
    if (value) {
      const { address } = value;
      this.setFormControls();

      if (!address) {
        this.addressSearchView(false, true);
      } else {
        this.addressSearchView(true, false);
        this.setEdit(address);
      }
    } else {
      this.addressSearchView(false, true);
    }
  }

  _disabled = false;

  @Input()
  set disabled(value) {
    this._disabled = value;
  }

  _noDirect: boolean = false;

  @Input()
  set noDirect(value) {
    this._noDirect = value;
  }

  _country;

  @Input()
  set country(country) {
    if (country) {
      this._country = country;
    }
  }

  _company;

  @Input()
  set company(compnay) {
    if (compnay) {
      this._company = compnay;
    }
  }

  _isCustomerDetailPage;

  @Input()
  set isCustomerDetailPage(isCustomerDetailPage) {
    if (isCustomerDetailPage) {
      this._isCustomerDetailPage = isCustomerDetailPage;
    }
  }

  get form() {
    return this.detailForm.controls;
  }

  ngOnInit(): void {
    if (!this.detailForm) {
      this.setFormControls();
    }

    this.googlePlacesAutocomplete.isAddressValid$.subscribe((value) => {
      if (value) {
        this.setAddressValid();
      }
    });

    this.googlePlacesAutocomplete.isReset$.subscribe((value) => {
      if (value) {
        this.addressEdit();
      }
    });

    this.isSECA = this.authService.getCurrentCompany() === Company.Seca;
    if ([this.companies.Seca].includes(this._company)) {
      const elementById = document.getElementById('edit_route');
      if (elementById) {
        elementById.removeAttribute('readonly');
        elementById.setAttribute('class', String('form-control'));
      }
    }
  }

  setFormControls() {
    this.detailForm = this.fb.group({
      address1: [null],
      address2: [null],
      city: [null],
      state: [null],
      zipcode: [null],
      country: [null],
    });
  }

  ngAfterViewInit() {
    this.googlePlacesAutocomplete.initEditAutocomplete(
      this._country,
      this.googleAutocompleteEdit.nativeElement
    );
  }

  reset(ev) {
    if (ev.isTrusted) {
      //this.onReset.emit();
      ['address1', 'address2', 'city', 'state', 'zipcode', 'country'].forEach(
        (item) => {
          this.detailForm.controls[item].setValue(null);
          this.detailForm.controls[item].setErrors(null);
        }
      );
    }
  }

  setAddressValid() {
    [
      {
        id: 'edit_route',
        key: 'address1',
        required: true,
      },
      {
        id: 'edit_address2',
        key: 'address2',
        required: false,
      },
      {
        id: 'edit_locality',
        key: 'city',
        required: true,
      },
      {
        id: 'edit_administrative_area_level_1',
        key: 'state',
        required: true,
      },
      {
        id: 'edit_postal_code',
        key: 'zipcode',
        required: true,
      },
      {
        id: 'edit_country',
        key: 'country',
        required: true,
      },
    ].forEach((item) => {
      const val = (document.getElementById(item.id) as HTMLInputElement).value;
      let error = { required: item.required, invalid: true, incorrect: true };
      if (val) {
        error = null;
      }
      this.detailForm.controls[item.key].setErrors(error);
    });

    this.detailForm.markAllAsTouched();
  }

  addressEdit() {
    // this.onReset.emit();
    ['address1', 'address2', 'city', 'state', 'zipcode', 'country'].forEach(
      item => {
        this.detailForm.controls[item].setValue(null);
        this.detailForm.controls[item].setErrors(null);
      }
    );

    this.addressSearchView(false, true);
    this.isReadOnly = true;
    return false;
  }

  addressSearchView(search, result) {
    (document.getElementById('edit-form-search') as HTMLInputElement).hidden =
      search;
    (document.getElementById('edit-form-result') as HTMLInputElement).hidden =
      result;
  }

  enableManualInput() {
    this.addressSearchView(true, false);
    this.isReadOnly = false;
  }

  private setEdit(address) {
    if (!address.address2) {
      address.address2 = '';
    }
    if (!address.country) {
      address.country = 'US';
    }
    this.detailForm.setValue(address);
  }
}
